export interface Manga {
  id: string;
  title: string;
  category: '韩漫' | '日漫' | '国漫';
  author: string;
  description: string;
  coverImage: string;
  rating: number;
  status: '连载中' | '已完结';
  chapters: number;
  updatedAt: string;
  tags: string[];
  views: number;
  longDescription: string;
}

export const categories = ['韩漫推荐', '日漫大全', '国漫排行榜'] as const;

export const categoryKeys: Record<string, '韩漫' | '日漫' | '国漫'> = {
  '韩漫推荐': '韩漫',
  '日漫大全': '日漫',
  '国漫排行榜': '国漫',
};

export const allManga: Manga[] = [
  {
    id: 'kr-1',
    title: '女神降临',
    category: '韩漫',
    author: '야옹이 / Meen',
    description: '平凡女孩通过化妆成为校园女神，却陷入两个男神的情感纠葛中，一段关于外貌、自卑与成长的故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20applying%20makeup%20in%20front%20of%20a%20mirror%2C%20soft%20pastel%20pink%20and%20peach%20background%2C%20romantic%20and%20glamorous%20atmosphere%2C%20clean%20manga%20cover%20design%20with%20Korean%20aesthetic%2C%20shojo%20style%20art%2C%20delicate%20linework&width=400&height=560&seq=manga-kr-01&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    chapters: 248,
    updatedAt: '2026-08-03',
    tags: ['恋爱', '校园', '成长', '颜值'],
    views: 1280000,
    longDescription: '从小因为外貌被霸凌的任朱静，通过化妆彻底改变了人生。转学后，她成为了众人眼中的女神。然而，围绕着她的两个男生——高冷学霸李修浩和阳光校草韩书俊，让她陷入了一段复杂又甜蜜的三角恋。在这场关于外貌、自信与真爱的成长故事中，朱静逐渐明白：真正的美丽来自内心，而非外表。《女神降临》以其细腻的情感刻画和时尚画风，成为韩国最受欢迎的网络漫画之一。',
  },
  {
    id: 'kr-2',
    title: '看脸时代',
    category: '韩漫',
    author: '朴泰俊',
    description: '一个备受欺凌的胖男孩突然拥有了两个身体，白天是完美型男，夜晚是原来的自己，展开双重人生。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20showing%20a%20striking%20contrast%20between%20two%20silhouettes%20of%20the%20same%20person%20one%20handsome%20and%20fit%20and%20one%20overweight%2C%20split%20composition%2C%20urban%20school%20setting%2C%20dramatic%20lighting%2C%20action%20genre%20manhwa%20cover%2C%20bold%20colors%20with%20red%20and%20black%20accents&width=400&height=560&seq=manga-kr-02&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    chapters: 420,
    updatedAt: '2026-08-02',
    tags: ['校园', '动作', '剧情', '双重人格'],
    views: 3500000,
    longDescription: '朴亨锡是一个因为外貌和身材而遭受校园霸凌的胖男孩。某天醒来，他突然发现自己拥有了一个完美的身体——高大帅气、体格健硕。白天，他可以使用这个完美身体上学；夜晚，他回到原本的身体继续生活。随着双重人生的展开，亨锡卷入了校园与社会的复杂纷争中。《看脸时代》以震撼的叙事和深刻的社会洞察，探讨了外貌歧视、校园暴力等现实问题，引发无数读者共鸣。',
  },
  {
    id: 'kr-3',
    title: '我独自升级',
    category: '韩漫',
    author: 'Chugong / DUBU',
    description: '最弱猎人成振宇在生死边缘觉醒特殊能力，从此踏上成为世界最强者的逆袭之路。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20powerful%20male%20character%20with%20dark%20hair%20and%20glowing%20purple%20eyes%20standing%20in%20a%20dungeon%2C%20shadow%20army%20behind%20him%2C%20dark%20fantasy%20atmosphere%2C%20epic%20action%20scene%2C%20cool%20tone%20and%20purple%20accents%2C%20hunter%20genre%20manhwa%20cover%2C%20dynamic%20composition&width=400&height=560&seq=manga-kr-03&orientation=portrait',
    rating: 9.7,
    status: '已完结',
    chapters: 179,
    updatedAt: '2025-12-25',
    tags: ['奇幻', '动作', '逆袭', '升级流'],
    views: 5600000,
    longDescription: '在这个世界中，出现了连接异次元的"门"，同时也诞生了被称为"猎人"的超能力者。成振宇身为最弱的E级猎人，在一次几乎全军覆没的双重地下城探险中奇迹生还，并获得了神秘的系统——一个可以让他无限升级的独特能力。从最底层一步步攀升，他收服暗影军团，击败强敌，最终成为足以拯救世界的存在。《我独自升级》以其爽快的升级节奏和震撼的战斗场面，成为全球现象级韩漫神作。',
  },
  {
    id: 'kr-4',
    title: '金秘书为何那样',
    category: '韩漫',
    author: '郑景允',
    description: '完美秘书金微笑突然提出辞职，让自恋副会长李英俊措手不及，一场啼笑皆非的追妻之旅就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20confident%20career%20woman%20in%20office%20attire%20and%20a%20handsome%20male%20boss%20in%20a%20suit%2C%20romantic%20comedy%20vibe%2C%20modern%20office%20background%20with%20warm%20golden%20lighting%2C%20elegant%20and%20chic%20design%2C%20light%20hearted%20atmosphere&width=400&height=560&seq=manga-kr-04&orientation=portrait',
    rating: 9.0,
    status: '已完结',
    chapters: 92,
    updatedAt: '2024-10-15',
    tags: ['恋爱', '职场', '喜剧', '霸总'],
    views: 980000,
    longDescription: '李英俊副会长——完美多金、自恋到极致的财阀继承人。金微笑秘书——在他身边默默工作了九年的完美秘书。当金微笑突然提出辞职，李英俊的世界彻底颠覆了。为了挽留这位无可替代的秘书，他使出浑身解数，甚至提出了令人震惊的提案。在这场职场与爱情交织的浪漫喜剧中，两人的关系逐渐从上司与下属，走向了更深的羁绊。《金秘书为何那样》以幽默风趣的叙事和精致画风征服了无数读者。',
  },
  {
    id: 'kr-5',
    title: '全知读者视角',
    category: '韩漫',
    author: 'Sing Shong / Sleepy-C',
    description: '平凡上班族金独子发现世界变成了自己追了十年的小说剧情，凭借对故事的了解开始改变命运。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20young%20man%20with%20glasses%20holding%20a%20book%20while%20standing%20in%20a%20post%20apocalyptic%20world%2C%20surrounded%20by%20glowing%20text%20and%20constellations%2C%20fantasy%20genre%2C%20mysterious%20and%20epic%20atmosphere%2C%20dark%20blue%20tone%20with%20golden%20accents&width=400&height=560&seq=manga-kr-05&orientation=portrait',
    rating: 9.4,
    status: '连载中',
    chapters: 210,
    updatedAt: '2026-08-01',
    tags: ['奇幻', '末世', '智者', '生存'],
    views: 2800000,
    longDescription: '金独子是一名普通的上班族，他唯一的爱好就是追一部连载了十多年的网络小说《在灭亡的世界中生存的三种方法》。当小说终于完结的那一天，他收到了作者发来的一封神秘邮件。紧接着，现实世界开始崩塌，一切都变得和小说中的场景一模一样——而他，成为了这个"故事"中唯一知道全部剧情的人。《全知读者视角》以其独特的世界观和深刻的人性探讨，被誉为韩国网文改编漫画的巅峰之作。',
  },
  {
    id: 'kr-6',
    title: '重生之都市修仙',
    category: '韩漫',
    author: 'TurtleMe / Fuyuki23',
    description: '仙界至尊渡劫失败重生回少年时代，这一世他要弥补所有遗憾，守护挚爱，登临巅峰！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20handsome%20young%20man%20with%20flowing%20dark%20hair%20surrounded%20by%20spiritual%20energy%20and%20ancient%20runes%2C%20martial%20arts%20cultivation%20theme%2C%20mix%20of%20modern%20city%20and%20ancient%20oriental%20elements%2C%20dramatic%20lighting%2C%20sword%20in%20hand%2C%20powerful%20aura&width=400&height=560&seq=manga-kr-06&orientation=portrait',
    rating: 8.9,
    status: '连载中',
    chapters: 156,
    updatedAt: '2026-07-28',
    tags: ['修仙', '重生', '都市', '爽文'],
    views: 1650000,
    longDescription: '仙界第一至尊林玄，在渡天劫时遭人暗算身陨。本以为就此灰飞烟灭，没想到竟重生回少年时代——那个还未踏上修仙之路的普通学生。带着前世的记忆与经验，他重新踏入修仙之路。这一世，他要弥补所有遗憾：提前守护即将遭遇不幸的家人，阻止挚爱之人的悲剧，找出前世暗算他的幕后黑手。从都市到仙界，他将以无敌之姿，再次登临诸天万界的巅峰！',
  },
  {
    id: 'kr-7',
    title: '나 혼자 만렙 뉴비',
    category: '韩漫',
    author: 'Maslow / WAN.Z',
    description: '万年新手玩家姜振赫意外获得隐藏职业，以满级新手的身份横扫游戏世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20young%20gamer%20with%20headphones%20in%20a%20virtual%20reality%20game%20world%2C%20holding%20a%20legendary%20weapon%2C%20surrounded%20by%20game%20UI%20elements%20and%20monsters%2C%20action%20packed%2C%20neon%20colors%2C%20game%20fantasy%20genre%2C%20dynamic%20pose&width=400&height=560&seq=manga-kr-07&orientation=portrait',
    rating: 9.0,
    status: '连载中',
    chapters: 198,
    updatedAt: '2026-07-30',
    tags: ['游戏', '奇幻', '冒险', '升级'],
    views: 1450000,
    longDescription: '在虚拟现实游戏《轮回》中，姜振赫是一个玩了好几年都没能升到满级的"万年新手"。某天，他意外触发了一个隐藏任务，获得了一个前所未有的隐藏职业。从此，他以"满级新手"的身份在这个游戏世界中横冲直撞——看似新手，却拥有超越所有人的战力。副本、BOSS战、PVP竞技，他用独特的玩法征服了一切。《满级新手》以其爽快的游戏对战和幽默的叙事风格深受读者喜爱。',
  },
  {
    id: 'kr-8',
    title: '剑尊归来',
    category: '韩漫',
    author: 'LICO / Redice Studio',
    description: '一代剑尊在雨夜中陨落，百年后重生为少年。这一世，他誓要以手中之剑斩尽天下不公。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20young%20swordsman%20with%20white%20hair%20holding%20a%20glowing%20sword%20in%20a%20moonlit%20night%2C%20ancient%20oriental%20palace%20in%20background%2C%20murim%20martial%20arts%20theme%2C%20elegant%20and%20powerful%20composition%2C%20cool%20blue%20and%20silver%20tones&width=400&height=560&seq=manga-kr-08&orientation=portrait',
    rating: 9.1,
    status: '连载中',
    chapters: 134,
    updatedAt: '2026-08-04',
    tags: ['武侠', '重生', '复仇', '热血'],
    views: 1100000,
    longDescription: '天下第一剑尊白云飞，在剿灭魔教的最后一战中遭到背叛，含恨陨落。一百年后，他以少年的身份重新醒来，却发现曾经的宗门已经没落，昔日的仇敌却成了名门正派。这一世的他，不再是那个盲信正义的天真剑客。他要用手中的剑，斩尽伪善，重塑天下秩序，让真正的剑道重新闪耀于世间。《剑尊归来》以华丽的画风和酣畅淋漓的战斗场面，成为武侠题材韩漫的标杆之作。',
  },
  {
    id: 'jp-1',
    title: '咒术回战',
    category: '日漫',
    author: '芥见下下',
    description: '高中生虎杖悠仁吞下诅咒之王的手指后，踏入咒术师的世界，与伙伴们一起对抗诅咒的战斗物语。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20a%20spiky%20haired%20teenage%20boy%20with%20supernatural%20energy%20surrounding%20his%20fists%2C%20urban%20Tokyo%20background%20with%20cursed%20spirits%2C%20action%20shonen%20genre%2C%20dynamic%20fighting%20pose%2C%20dark%20and%20edgy%20atmosphere%2C%20bold%20linework%20with%20red%20accents&width=400&height=560&seq=manga-jp-01&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    chapters: 271,
    updatedAt: '2026-08-03',
    tags: ['热血', '战斗', '超自然', '校园'],
    views: 4800000,
    longDescription: '在这个世界中，人类的负面情绪会化为"诅咒"，威胁着人们的生命。高中生虎杖悠仁在偶然的机会下吞下了诅咒之王"两面宿傩"的手指，从此被卷入了咒术师的世界。为了收集散落在各地的宿傩手指，他进入了东京都立咒术高等专门学校，与伏黑惠、钉崎野蔷薇等伙伴一同踏上消灭诅咒的征程。然而，隐藏在这条道路背后的，是一个关于人性、宿命与友情的宏大故事。',
  },
  {
    id: 'jp-2',
    title: '海贼王',
    category: '日漫',
    author: '尾田荣一郎',
    description: '少年路飞立志成为海贼王，与伙伴们在大海上展开寻找传说宝藏的伟大冒险。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20a%20grinning%20young%20pirate%20with%20a%20straw%20hat%20standing%20on%20a%20pirate%20ship%20with%20a%20crew%20behind%20him%2C%20vast%20ocean%20and%20blue%20sky%20background%2C%20adventure%20and%20friendship%20theme%2C%20warm%20and%20bright%20colors%2C%20iconic%20shonen%20style%2C%20exciting%20composition&width=400&height=560&seq=manga-jp-02&orientation=portrait',
    rating: 9.8,
    status: '连载中',
    chapters: 1120,
    updatedAt: '2026-08-04',
    tags: ['冒险', '热血', '友情', '奇幻'],
    views: 8900000,
    longDescription: '被称作"海贼王"的哥尔·D·罗杰在临刑前的一句话，开启了"大海贼时代"的序幕。少年蒙奇·D·路飞受到红发香克斯的启发，立志要找到传说中的大秘宝"ONE PIECE"，成为海贼王。他一路召集伙伴——剑士索隆、航海士娜美、狙击手乌索普、厨师山治……草帽一伙的冒险跨越无数岛屿，对抗强大的敌人，探寻历史的真相。《海贼王》是日本漫画史上最伟大的作品之一，全球销量超过5亿册。',
  },
  {
    id: 'jp-3',
    title: '间谍过家家',
    category: '日漫',
    author: '远藤达哉',
    description: '间谍、杀手、超能力少女组成虚假家庭，却在共同生活中萌生了真挚的亲情。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20a%20family%20of%20three%20a%20man%20in%20a%20suit%20a%20woman%20with%20red%20hair%20and%20a%20little%20pink%20haired%20girl%20with%20a%20stuffed%20animal%2C%20warm%20and%20comedic%20atmosphere%2C%20pastel%20colors%2C%20spy%20and%20family%20comedy%20theme%2C%20stylish%20design&width=400&height=560&seq=manga-jp-03&orientation=portrait',
    rating: 9.4,
    status: '连载中',
    chapters: 105,
    updatedAt: '2026-07-28',
    tags: ['喜剧', '家庭', '间谍', '温馨'],
    views: 3200000,
    longDescription: '为了执行秘密任务"枭"，西国顶尖间谍"黄昏"需要在七天内组建一个家庭。他收养了能读心的超能力少女阿尼亚，与身份是杀手的约尔缔结了契约婚姻。三人各怀秘密，却在一系列啼笑皆非的事件中，逐渐建立起真正的羁绊。爸爸是间谍，妈妈是杀手，女儿是超能力者——这个世界上最"不普通"的普通家庭，却上演着最温馨动人的日常。《间谍过家家》以其独特的设定和温暖人心的故事席卷全球。',
  },
  {
    id: 'jp-4',
    title: '鬼灭之刃',
    category: '日漫',
    author: '吾峠呼世晴',
    description: '少年炭治郎全家被鬼杀害，妹妹祢豆子变成鬼，他踏上斩杀鬼王、让妹妹恢复人类的旅程。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20a%20young%20swordsman%20with%20a%20checkered%20haori%20coat%20and%20a%20girl%20with%20a%20bamboo%20muzzle%2C%20traditional%20Japanese%20setting%20with%20cherry%20blossoms%2C%20water%20breathing%20effects%2C%20Taisho%20era%20aesthetic%2C%20emotional%20and%20beautiful%20composition&width=400&height=560&seq=manga-jp-04&orientation=portrait',
    rating: 9.5,
    status: '已完结',
    chapters: 205,
    updatedAt: '2024-05-18',
    tags: ['热血', '战斗', '兄妹情', '和风'],
    views: 6200000,
    longDescription: '大正时代，卖炭少年灶门炭治郎在一夜之间失去了所有家人——除了妹妹祢豆子。但祢豆子已经变成了食人鬼。为了寻找让妹妹恢复为人类的方法，炭治郎加入了鬼杀队，踏上了一条充满血与泪的斩鬼之路。从最终选拔到无限城决战，炭治郎与伙伴们一同面对十二鬼月和鬼舞辻无惨，用生命守护人类。《鬼灭之刃》以其细腻的情感刻画和壮丽的战斗场面，创造了日本漫画史上的销量奇迹。',
  },
  {
    id: 'jp-5',
    title: '葬送的芙莉莲',
    category: '日漫',
    author: '山田钟人 / 阿部司',
    description: '勇者队伍打败魔王后，长寿精灵芙莉莲踏上了解人类情感的旅程，重新认识与勇者之间的羁绊。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20an%20elf%20girl%20with%20long%20silver%20hair%20and%20a%20staff%20walking%20through%20a%20flower%20field%2C%20nostalgic%20and%20melancholic%20atmosphere%2C%20fantasy%20world%20with%20soft%20sunset%20lighting%2C%20emotional%20and%20bittersweet%20tone%2C%20beautiful%20pastel%20colors&width=400&height=560&seq=manga-jp-05&orientation=portrait',
    rating: 9.6,
    status: '连载中',
    chapters: 138,
    updatedAt: '2026-08-02',
    tags: ['奇幻', '治愈', '冒险', '哲学'],
    views: 2800000,
    longDescription: '勇者欣梅尔、僧侣海塔、战士艾冉和精灵魔法使芙莉莲，四人历经十年冒险，终于打败了魔王，为世界带来了和平。在庆功宴上，他们约定五十年后再一起看流星雨。对于活了上千年的精灵芙莉莲来说，五十年不过弹指一挥间。当她如约回到那个地方时，却发现勇者欣梅尔已经白发苍苍。不久后，欣梅尔去世了。在葬礼上，芙莉莲意识到自己从未真正了解过这个人类伙伴。于是，她踏上了理解人类情感的旅程。《葬送的芙莉莲》是一部关于时间、记忆与爱的温柔史诗。',
  },
  {
    id: 'jp-6',
    title: '电锯人',
    category: '日漫',
    author: '藤本树',
    description: '穷困少年淀治与电锯恶魔波奇塔融合，成为公安恶魔猎人，以最疯狂的方式追求平凡的幸福。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20a%20blond%20teenage%20boy%20with%20chainsaw%20blades%20coming%20out%20of%20his%20head%20and%20arms%2C%20urban%20night%20setting%20with%20neon%20signs%2C%20bloody%20and%20chaotic%20atmosphere%2C%20dark%20comedy%20and%20action%2C%20grungy%20and%20raw%20art%20style&width=400&height=560&seq=manga-jp-06&orientation=portrait',
    rating: 9.1,
    status: '连载中',
    chapters: 185,
    updatedAt: '2026-07-31',
    tags: ['黑暗', '动作', '猎奇', '剧情'],
    views: 3500000,
    longDescription: '淀治是一个背负着父亲巨额债务的穷困少年。他与宠物恶魔波奇塔——一只长得像电锯的小狗——相依为命，靠猎杀恶魔勉强维生。某天，他被黑帮背叛并被恶魔杀死，濒死之际，波奇塔与他融合，使他成为了"电锯人"。被公安对魔特异4课收编后，淀治以公安恶魔猎人的身份开始了全新的生活。他的梦想很简单：吃上面包涂果酱、和女孩子约会。然而，在这个恶魔横行的世界里，平凡的幸福却是最奢侈的东西。',
  },
  {
    id: 'jp-7',
    title: '蓝色监狱',
    category: '日漫',
    author: '金城宗幸 / 野村优介',
    description: '300名天才高中前锋被关进蓝色监狱，为了打造世界第一自私的前锋展开残酷淘汰赛。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20intense%20soccer%20players%20in%20blue%20uniforms%20running%20on%20a%20futuristic%20indoor%20field%20with%20dramatic%20lighting%2C%20sports%20action%20genre%2C%20dynamic%20movement%2C%20cool%20blue%20tone%2C%20competitive%20and%20intense%20atmosphere&width=400&height=560&seq=manga-jp-07&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    chapters: 280,
    updatedAt: '2026-08-03',
    tags: ['运动', '竞技', '足球', '热血'],
    views: 2100000,
    longDescription: '日本足球联盟为了培养出世界第一的前锋，启动了一个疯狂的计划——"蓝色监狱"。300名来自全国各地的天才高中前锋被聚集在一个封闭设施中，进行残酷的淘汰赛。规则很简单：最后留下的人将成为日本代表队的绝对王牌，而其他人则永远失去入选国家队的资格。洁世一，一个在高中比赛中因为"不够自私"而错失进球的少年，将在这个修罗场中彻底改变自己。这是关于利己主义者的足球生存游戏！',
  },
  {
    id: 'jp-8',
    title: '怪兽8号',
    category: '日漫',
    author: '松本直也',
    description: '32岁清理工日比野卡夫卡意外获得变身怪兽的能力，以超龄新人的身份加入防卫队对抗怪兽。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20illustration%20of%20a%20man%20partially%20transforming%20into%20a%20monster%20with%20glowing%20blue%20veins%2C%20in%20the%20middle%20of%20a%20destroyed%20city%2C%20fighting%20a%20giant%20kaiju%2C%20sci%20fi%20action%20genre%2C%20epic%20scale%2C%20dynamic%20and%20powerful%20composition&width=400&height=560&seq=manga-jp-08&orientation=portrait',
    rating: 9.0,
    status: '连载中',
    chapters: 115,
    updatedAt: '2026-07-25',
    tags: ['科幻', '怪兽', '战斗', '热血'],
    views: 1800000,
    longDescription: '在一个被怪兽频繁袭击的世界里，日本防卫队是与怪兽作战的最强力量。日比野卡夫卡从小就梦想加入防卫队，但屡试不中，最终只能在怪兽清扫公司做着清理怪兽尸体的工作。32岁那年，一只神秘的小怪兽进入了他的身体，赋予了他变身成为怪兽的能力。被命名为"怪兽8号"的他，终于获得了加入防卫队的机会。以一个"大叔新人"的身份，他将在这个年轻时就要拼命的战场上证明自己的价值。',
  },
  {
    id: 'cn-1',
    title: '一人之下',
    category: '国漫',
    author: '米二',
    description: '普通大学生张楚岚卷入异人世界，揭开爷爷留下的惊天秘密，踏上异人之旅。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20young%20man%20with%20black%20hair%20using%20supernatural%20qi%20energy%20from%20his%20palm%2C%20traditional%20Chinese%20village%20background%20with%20ancient%20temples%2C%20martial%20arts%20and%20mystical%20theme%2C%20dynamic%20action%20pose%2C%20rich%20oriental%20aesthetics&width=400&height=560&seq=manga-cn-01&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    chapters: 650,
    updatedAt: '2026-08-03',
    tags: ['奇幻', '都市', '异能', '武侠'],
    views: 4200000,
    longDescription: '张楚岚原本只是一个普通的大学生，最大的烦恼就是期末考试。然而，当爷爷的坟墓被盗，神秘的"异人"世界突然闯入他的生活。体内流淌的炁体源流，让他成为了整个异人界追逐的目标。在神秘少女冯宝宝的"保护"下，张楚岚加入了哪都通快递公司——一个异人组织的外壳，开始探寻爷爷留下的秘密。《一人之下》将中国传统道教文化与现代都市异能完美融合，是中国漫画的里程碑之作。',
  },
  {
    id: 'cn-2',
    title: '狐妖小红娘',
    category: '国漫',
    author: '小新',
    description: '狐妖涂山苏苏为前世恋人们牵线续缘，一段段跨越人妖两界的动人爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20cute%20fox%20girl%20with%20orange%20hair%20and%20fox%20ears%20in%20traditional%20Chinese%20dress%2C%20surrounded%20by%20floating%20red%20ribbons%20and%20cherry%20blossoms%2C%20romantic%20fantasy%20theme%2C%20ancient%20Chinese%20setting%2C%20warm%20and%20dreamy%20colors&width=400&height=560&seq=manga-cn-02&orientation=portrait',
    rating: 9.4,
    status: '连载中',
    chapters: 580,
    updatedAt: '2026-08-02',
    tags: ['恋爱', '奇幻', '古风', '治愈'],
    views: 3800000,
    longDescription: '在人与妖共存的世界中，狐妖一族有一个特殊的职业——"红娘"。她们为前世相恋却因寿命差距未能白首的人与妖牵线搭桥，通过"转世续缘"让他们在来世重逢相爱。涂山苏苏是一只笨拙但执着的小狐妖，在她的一桩桩续缘任务中，一段段跨越时空的动人爱情故事徐徐展开。而她自己与道士白月初之间，也隐藏着一段被遗忘的前世约定。《狐妖小红娘》以其唯美的画风和催泪的爱情故事，成为中国最受欢迎的恋爱漫画。',
  },
  {
    id: 'cn-3',
    title: '斗罗大陆',
    category: '国漫',
    author: '唐家三少 / 穆逢春',
    description: '唐门外门弟子唐三穿越到斗罗大陆，以唐门绝学在这个武魂世界中一步步走向巅峰。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20young%20man%20with%20long%20blue%20hair%20summoning%20a%20blue%20silver%20grass%20martial%20spirit%2C%20fantasy%20world%20with%20spirit%20rings%20floating%20around%20him%2C%20epic%20cultivation%20theme%2C%20dramatic%20and%20grand%20composition%2C%20vibrant%20colors&width=400&height=560&seq=manga-cn-03&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    chapters: 420,
    updatedAt: '2026-08-04',
    tags: ['奇幻', '穿越', '热血', '修炼'],
    views: 7200000,
    longDescription: '唐门外门弟子唐三，因偷学内门绝学被逼跳崖明志。当他再次睁开眼时，发现自己来到了一个名为"斗罗大陆"的全新世界。这里没有武功，没有暗器，只有一种名为"武魂"的力量。唐三带着前世的唐门绝学，在这个世界从零开始。从圣魂村的普通少年，到史莱克七怪的核心，再到海神岛的继承人，他以蓝银草为起点，一路披荆斩棘，最终成为了斗罗大陆上最强大的神祇。《斗罗大陆》是中国最畅销的网络小说改编漫画，影响力遍及全球。',
  },
  {
    id: 'cn-4',
    title: '镇魂街',
    category: '国漫',
    author: '许辰',
    description: '少女夏铃误入镇魂街，与罗刹街镇魂将曹焱兵相遇，鬼域与人间的惊天秘密逐渐浮出水面。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20fierce%20young%20man%20with%20red%20and%20black%20armor%20holding%20a%20large%20weapon%2C%20standing%20in%20a%20ghostly%20street%20with%20ancient%20Chinese%20buildings%2C%20supernatural%20guardian%20spirits%20behind%20him%2C%20dark%20and%20mysterious%20atmosphere&width=400&height=560&seq=manga-cn-04&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    chapters: 380,
    updatedAt: '2026-07-29',
    tags: ['奇幻', '战斗', '热血', '守护灵'],
    views: 2900000,
    longDescription: '在这个世界的暗面，存在着一条特别的街道——镇魂街。这里是灵魂的聚集地，也是镇魂将守护人类世界的战场。大学毕业生夏铃在求职途中意外闯入罗刹街，遇见了桀骜不驯的镇魂将曹焱兵。随着两人命运的交织，一个关乎人灵两界的巨大阴谋逐渐浮现。曹焱兵背负着父亲失踪的秘密，夏铃身上也隐藏着不为人知的力量。他们将在这条充满亡魂的街道上，揭开尘封千年的真相。',
  },
  {
    id: 'cn-5',
    title: '全职高手',
    category: '国漫',
    author: '蝴蝶蓝 / 常盘勇者',
    description: '荣耀第一人叶修被俱乐部驱逐后，从网吧重新开始，用一把千机伞重回职业巅峰。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20cool%20young%20man%20with%20messy%20hair%20sitting%20at%20a%20computer%20in%20an%20internet%20cafe%2C%20surrounded%20by%20floating%20game%20screens%20and%20skill%20effects%2C%20esports%20theme%2C%20competitive%20and%20determined%20atmosphere%2C%20modern%20urban%20setting&width=400&height=560&seq=manga-cn-05&orientation=portrait',
    rating: 9.6,
    status: '已完结',
    chapters: 320,
    updatedAt: '2025-08-15',
    tags: ['电竞', '热血', '竞技', '逆袭'],
    views: 5600000,
    longDescription: '叶修——荣耀网游的传奇人物，被誉为"荣耀教科书"级别的顶尖高手。然而，由于商业利益的冲突，他被自己一手建立的嘉世俱乐部无情驱逐。离开职业圈的他，在一个不起眼的网吧里重新开始。手持自制的银武"千机伞"，他从新区第十区一步步杀回职业联盟。这一次，他不是一个人在战斗——网吧老板陈果、新人唐柔、包子入侵……一支全新的战队正在集结。荣耀，不只是一场游戏。《全职高手》是中国电竞题材作品的巅峰。',
  },
  {
    id: 'cn-6',
    title: '镖人',
    category: '国漫',
    author: '许先哲',
    description: '隋末乱世，镖客刀马带着小七行走西域，一次护送任务引出一场惊天大阴谋。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20rugged%20warrior%20with%20a%20sword%20and%20a%20child%20riding%20a%20horse%20through%20the%20desert%2C%20ancient%20Silk%20Road%20setting%2C%20Sui%20Dynasty%20era%2C%20grimy%20and%20realistic%20art%20style%2C%20western%20Chinese%20landscape%2C%20gritty%20and%20atmospheric&width=400&height=560&seq=manga-cn-06&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    chapters: 128,
    updatedAt: '2026-06-20',
    tags: ['武侠', '历史', '硬派', '江湖'],
    views: 1800000,
    longDescription: '隋朝末年，天下大乱，民不聊生。身怀绝技的镖客刀马带着年幼的小七，在荒凉的大漠中行走。江湖上有一条规矩：不问来历，只收钱办事。刀马接下一单镖——护送一个来历神秘的面具人前往长安。然而这趟看似普通的镖，却牵扯出一个足以颠覆王朝的惊天阴谋。朝廷鹰犬、西域马匪、武林高手……各方势力纷纷登场。《镖人》以其硬派写实的画风和震撼人心的叙事，被誉为"中国漫画的硬核之光"。',
  },
  {
    id: 'cn-7',
    title: '完美世界',
    category: '国漫',
    author: '辰东 / 阿曼',
    description: '石昊天生至尊骨被夺，他以凡体逆天而上，在万族林立的完美世界中开创不朽传奇。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20young%20boy%20with%20wild%20hair%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20primitive%20world%2C%20ancient%20beasts%20flying%20in%20the%20sky%2C%20cultivation%20fantasy%20theme%2C%20epic%20and%20grand%20scale%2C%20mystical%20golden%20light%20surrounding%20him&width=400&height=560&seq=manga-cn-07&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    chapters: 360,
    updatedAt: '2026-08-01',
    tags: ['奇幻', '修炼', '热血', '逆袭'],
    views: 4500000,
    longDescription: '在下界的石村中，一个叫石昊的孩子出生了。天生至尊骨的他，本应是万中无一的天才。然而，至尊骨被族人残忍夺走，他被抛弃在荒山野岭。石村的老族长收养了他，将他抚养长大。天赋被夺又如何？石昊以凡体之资，在这片万族林立、凶兽横行的蛮荒世界中杀出一条血路。从石村到大荒，从上界到九天十地，他将用实力证明：至尊从来就不是天生的——至尊之路，是用热血与不屈踏出来的！',
  },
  {
    id: 'cn-8',
    title: '大理寺日志',
    category: '国漫',
    author: 'RC',
    description: '唐朝大理寺中，一只白猫少卿与一众官员联手破案，揭开隐藏在盛世之下的惊天秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20cover%20illustration%20of%20a%20white%20cat%20wearing%20traditional%20Chinese%20official%20robes%20standing%20in%20an%20ancient%20Tang%20Dynasty%20government%20office%2C%20mystery%20and%20historical%20theme%2C%20warm%20candlelight%20atmosphere%2C%20detailed%20architecture%2C%20comedic%20yet%20elegant%20vibe&width=400&height=560&seq=manga-cn-08&orientation=portrait',
    rating: 9.1,
    status: '连载中',
    chapters: 240,
    updatedAt: '2026-07-20',
    tags: ['历史', '悬疑', '喜剧', '古风'],
    views: 1350000,
    longDescription: '大唐盛世，武周时期。洛阳大理寺中，新上任的少卿是一只……白猫？这只名叫李饼的白猫少卿，身世成谜，性情古怪。他率领大理寺的一众官员——包括老实巴交的陈拾、武艺高强的阿里巴巴、精通医术的崔倍——在繁荣的洛阳城中处理一桩桩离奇案件。从市井小案到宫廷密谋，一桩桩事件背后，是隐藏在盛世之下的暗流涌动。《大理寺日志》以精妙的历史细节和幽默的叙事风格，打造了一个独特的大唐悬疑世界。',
  },
];

export const getMangaByCategory = (category: string): Manga[] => {
  return allManga.filter((m) => m.category === category);
};

export const getMangaById = (id: string): Manga | undefined => {
  return allManga.find((m) => m.id === id);
};

export const getLatestManga = (limit: number = 8): Manga[] => {
  return [...allManga].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getTopRatedManga = (limit: number = 10): Manga[] => {
  return [...allManga].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getPopularManga = (limit: number = 10): Manga[] => {
  return [...allManga].sort((a, b) => b.views - a.views).slice(0, limit);
};